import { createAction, props } from '@ngrx/store';
import { BankingStateModel } from '@stores/banking/banking-ngrx.reducer';
import {
  BankingBankAccount,
  BankingBankInfo,
  BankingPartner,
  BankingPersonalInformation,
  BankingUser,
  UserEligibility,
} from '@wizbii/utils/models';

export const InitBankingStateSuccess = createAction(
  '[BankingState] InitBankingStateSuccess',
  props<BankingStateModel>()
);
export const UpdateBankingUser = createAction(
  '[BankingState] UpdateUser',
  props<{
    user: BankingUser | null;
    redirectUrl?: string[];
    redirectOptions?: { queryParams: Record<string, string> };
  }>()
);

export const CreateBankingUserIfEligible = createAction('[BankingState] CreateBankingUserIfEligible');
export const CreateBankingUserIfEligibleSuccess = createAction(
  '[BankingState] CreateBankingUserIfEligible success',
  props<{ user: BankingUser | null }>()
);

export const UpdateBankingBankInfos = createAction(
  '[BankingState] UpdateBankInfos',
  props<{ bankInfos: BankingBankInfo | null }>()
);

export const UpdateBankingBankAccount = createAction(
  '[BankingState] UpdateBankAccount',
  props<{ bankAccount: BankingBankAccount | null }>()
);

export const UpdateBankingPersonalInformation = createAction(
  '[BankingState] PersonalInformation',
  props<{ personalInformation: BankingPersonalInformation }>()
);

export const CheckUserEligibility = createAction(
  '[BankingState] UserEligibility',
  props<{ eligibility: UserEligibility }>()
);

export const UpdateBankingPartner = createAction(
  '[BankingState] Update Banking Partner',
  props<{ bankingPartner: BankingPartner }>()
);
